export const siteConfig = {
  name:        "Sri Sai Institute of Agriculture Sciences",
  nameShort:   "Sri Sai Agri Institute",
  tagline:     "Sri Sai Institute of Agriculture Sciences · Poranki, Vijayawada",
  motto:       "Empowering the Future of Agriculture.",
  philosophy:  "Excellence in Agricultural Education & Research",
  legacy:      "9 Years of Academic Excellence",
  accreditation: "Recognised by Govt. of A.P. & Affiliated to Lucknow University",
  phones: ["7550252015", "6281084741", "7997882246"],
  phonesDisplay: "7550252015 / 6281084741 / 7997882246",
  email:   "srisaiagriculture1@gmail.com",
  address: "#11-87 Panta Kalva Road, Balaji Nagar, Sali Peta Road, Near Water Tank, Poranki, Vijayawada - 521137",
  officeHours: "Monday – Saturday: 8:00 AM – 6:00 PM",
  admissionsStatus: "Admissions are in progress — Make it happen!",
};


